<div class="content-wrapper" [class.edit-mode]="editMode">

    <ng-container *ngIf="!isUnset; else unsetGantt">
        <pv-report-gantt-graph [ganttControl]="ganttControl" [compiledData]="compiledData" [typography]="typography"></pv-report-gantt-graph>

        <div *ngIf="hasNoData" class="component-placeholder gantt-no-data">
            <mat-icon class="material-symbols-outlined placeholder-icon">event_busy</mat-icon>
            <span class="placeholder-title">No dates to plot</span>
            <span class="placeholder-hint">No values were found for the selected date characteristic(s) in this context. Try a different characteristic or context.</span>
        </div>
    </ng-container>

    <ng-template #unsetGantt>
        <div *ngIf="editMode" class="component-placeholder">
            <mat-icon class="material-symbols-outlined placeholder-icon">timeline</mat-icon>
            <span class="placeholder-title">Gantt Chart</span>
            <span class="placeholder-hint">Open the menu to configure date characteristics and context</span>
        </div>
    </ng-template>

    <div *ngIf="editMode" class="content-options no-print">
        <button mat-icon-button
                [matTooltip]="axisStartWeek === 27 ? 'Axis: split year (W27–W26) — switch to calendar' : 'Axis: calendar year (W01–W53) — switch to split year'"
                (click)="toggleAxisStart()">
            <mat-icon class="material-symbols-outlined">
                {{ axisStartWeek === 27 ? 'sync_alt' : 'calendar_today' }}
            </mat-icon>
        </button>
        <button mat-icon-button
                [matTooltip]="viewMode === 'full' ? 'Zoom to data' : 'Show full year (W01–W53)'"
                (click)="toggleViewMode()">
            <mat-icon class="material-symbols-outlined">
                {{ viewMode === 'full' ? 'center_focus_strong' : 'zoom_out_map' }}
            </mat-icon>
        </button>
        <button mat-icon-button matTooltip="Item Actions" [matMenuTriggerFor]="optionMenu">
            <mat-icon>more_vert</mat-icon>
        </button>
    </div>

</div>

<mat-menu #optionMenu>
    <ng-template matMenuContent>
        <button mat-menu-item (click)="edit()">
            <mat-icon>edit</mat-icon>
            <span>Edit Item</span>
        </button>
        <button mat-menu-item (click)="remove()">
            <mat-icon>delete</mat-icon>
            <span>Delete Item</span>
        </button>
        <!-- Duplicate temporarily hidden
        <button mat-menu-item (click)="makeDuplicate()">
            <mat-icon>content_copy</mat-icon>
            <span>Duplicate</span>
        </button>
        -->
        <button mat-menu-item (click)="editTypography.emit()">
            <mat-icon class="material-symbols-outlined">text_fields</mat-icon>
            <span>Font</span>
        </button>
        <button mat-menu-item [matMenuTriggerFor]="layering">
            <mat-icon class="material-symbols-outlined">stack</mat-icon>
            <span>Layering ({{ layerIndex }})</span>
        </button>
    </ng-template>
</mat-menu>

<mat-menu #layering="matMenu">
    <button mat-menu-item (click)="moveToTop()">
        <mat-icon class="material-symbols-outlined">arrow_shape_up_stack</mat-icon>
        <span>Send to Top</span>
    </button>
    <button mat-menu-item (click)="moveForward()">
        <mat-icon class="material-symbols-outlined">arrow_shape_up</mat-icon>
        <span>Move Forward</span>
    </button>
    <button mat-menu-item (click)="moveDown()">
        <mat-icon class="material-symbols-outlined flipped-icon">arrow_shape_up</mat-icon>
        <span>Move Down</span>
    </button>
    <button mat-menu-item (click)="moveToBottom()">
        <mat-icon class="material-symbols-outlined flipped-icon">arrow_shape_up_stack</mat-icon>
        <span>Send to Back</span>
    </button>
</mat-menu>
